import { render, staticRenderFns } from "./bureau.vue?vue&type=template&id=90c6183e&scoped=true&"
import script from "./bureau.vue?vue&type=script&lang=js&"
export * from "./bureau.vue?vue&type=script&lang=js&"
import style0 from "./bureau.vue?vue&type=style&index=0&id=90c6183e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c6183e",
  null
  
)

export default component.exports